import {
    TOGGLE_BREADCRUMBS as SOURCE_TOGGLE_BREADCRUMBS,
    toggleBreadcrumbs as sourceToggleBreadcrumbs,
    UPDATE_BREADCRUMBS as SOURCE_UPDATE_BREADCRUMBS,
    updateBreadcrumbs as sourceUpdateBreadcrumbs
} from 'SourceStore/Breadcrumbs/Breadcrumbs.action';

// TODO: implement UPDATE_BREADCRUMBS
export const UPDATE_BREADCRUMBS = SOURCE_UPDATE_BREADCRUMBS;

// TODO: implement TOGGLE_BREADCRUMBS
export const TOGGLE_BREADCRUMBS = SOURCE_TOGGLE_BREADCRUMBS;

// TODO: implement updateBreadcrumbs
export const updateBreadcrumbs = sourceUpdateBreadcrumbs;

// TODO: implement toggleBreadcrumbs
export const toggleBreadcrumbs = sourceToggleBreadcrumbs;
